module.exports = __webpack_public_path__ + "img/hainan.9e69c4ce.png";